import { Alignment, Fit, Layout } from '@rive-app/react-canvas';

import { useRiveMachine } from '../../../../hooks/rive/useRiveMachine';
import { useStores } from '../../../../stores/useStores';

interface RiveBannersAnimationProps {
  riveFileUrl: string;
  fullHeight?: boolean;
}

export const useRiveBannersAnimation = ({ riveFileUrl, fullHeight = false }: RiveBannersAnimationProps) => {
  const { uiStore } = useStores();

  const src = uiStore.bannerAnimationFlag ? riveFileUrl : '';

  const {
    rive,
    isLoading: isRiveLoading,
    RiveComponent,
    error,
    timeoutError,
  } = useRiveMachine({
    src,
    autoplay: true,
    layout: new Layout({
      fit: fullHeight ? Fit.FitHeight : Fit.Contain,
      alignment: Alignment.BottomCenter,
    }),
  });

  const hasError = Boolean(error) || Boolean(timeoutError);

  if (!riveFileUrl || !uiStore.bannerAnimationFlag) return { RiveComponent, showRive: false };

  return {
    RiveComponent,
    showRive: !!riveFileUrl && !hasError,
    rive,
    isRiveLoading,
  };
};
